// extracted by mini-css-extract-plugin
export default {"mainContainer":"Experience_mainContainer__KWoHH","emphasis":"Experience_emphasis__Bie5I"};